interface ITextHeadingProps {
  text: string;
  className?: string;
}

const TextHeading = ({ text, className }: ITextHeadingProps) => {
  return (
    <h1 className={`text-color-02 font-bold text-heading-02 ${className}`}>
      {text}
    </h1>
  );
};

export default TextHeading;
